import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';

function* getChatMessages(action) {
  let response = null;
  try {
    response = yield call(
      requestAPI,
      API.GET_CHAT_MESSAGE,
      API.GET,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_CHAT_MESSAGES_REQUEST_SUCCEEDED,
        data: response.data
      });
    } else if (response.status === ResponseStatus.FAILURE) {
      yield put({
        type: types.GET_CHAT_MESSAGES_REQUEST_FAILED,
        error: response
      });
    } else {
      yield put({
        type: types.GET_CHAT_MESSAGES_REQUEST_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.GET_CHAT_MESSAGES_REQUEST_FAILED, error });
  }
}

export function* watchGetChatMessages() {
  yield takeLatest(types.GET_CHAT_MESSAGES_REQUESTED, getChatMessages);
}
